var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.empty),expression:"empty"}],staticClass:"empty"},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_c('span',{staticStyle:{"color":"#c0c0c0","font-size":"0.6rem"}},[_vm._v(" 暂无数据 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }